
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[festivalId]/live",
      function () {
        return require("private-next-pages/[festivalId]/live.js");
      }
    ]);
  